import BaseModel from '../core/BaseModel'
export default class DistrictModel extends BaseModel {
    constructor() {
        super({ 
                name: "districts",
                tableName: 'core_district'
            },
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}